document.addEventListener('DOMContentLoaded', () => {

  const wrappers = document.querySelectorAll('.image-cta-wrapper');

  wrappers.forEach(wrapper => {

    const container = wrapper.querySelector('.image-cta-container');
    const leftBtn   = wrapper.querySelector('.cta-scroll--left');
    const rightBtn  = wrapper.querySelector('.cta-scroll--right');
    const card      = container.querySelector('.image-cta-item');
    if (!card) return;

    /* tag wrapper with number of tiles: cta-count-2, cta-count-3, etc. */
    const itemCount = container.children.length;
    wrapper.classList.add(`cta-count-${itemCount}`);

    /* calculate scroll distance (one tile + gap) */
    const gap  = parseFloat(getComputedStyle(container).gap) || 0;
    const step = card.offsetWidth + gap;

    /* click-to-scroll */
    leftBtn.addEventListener('click', ()  =>
      container.scrollBy({ left: -step, behavior: 'smooth' })
    );
    rightBtn.addEventListener('click', () =>
      container.scrollBy({ left:  step, behavior: 'smooth' })
    );

    /* show / hide arrows based on scroll position */
    const updateArrows = () => {
      const maxScroll = container.scrollWidth - container.clientWidth - 1; // rounding fudge
      const atStart   = container.scrollLeft <= 0;
      const atEnd     = container.scrollLeft >= maxScroll;
      leftBtn.classList.toggle('is-hidden', atStart);
      rightBtn.classList.toggle('is-hidden', atEnd);
    };

    /* initial state + listeners */
    updateArrows();
    container.addEventListener('scroll',  updateArrows);
    window.addEventListener('resize',     updateArrows);

  });

});
